import { z } from 'zod';
import { createRepo } from './_base.js';

const HostnameToBrandSchema = z.object({ platformBrandId: z.string() });
export const hostnameToBrandRepo = createRepo({
  path: 'hostnameToBrand',
  schema: HostnameToBrandSchema,
  name: 'hostnameToBrand',
});

const SlugToTenantIdSchema = z.object({ tenantId: z.string() });
export const slugToTenantIdRepo = createRepo({
  path: 'slugToTenantId',
  schema: SlugToTenantIdSchema,
  name: 'slugToTenantId',
});
